const content = {
    'lyft_ride_history': {
        en: {
            data_type_description: 'Lyft Ride History',
            summary_html: `<p>Retro jobs are simple, quick and a bit of fun too. Watch the video and read the steps below,
            and then you're ready to hit record and scroll through your trips history.</p>`,
            summary_no_video_html: `<p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then
            you're ready to hit record and scroll through your trips history.</p>`,
            footer_html: `
            <p>Please note that you must share a ride history with at least one Lyft trip in order to qualify for the MSR
                points for this data task.</p>
            <h3>📈 Data task</h3>
            <p>Data tasks involve completing a job that requires you to share some data in exchange for a MSR reward. This
                may be via a survey, screenshot, screen recording or file upload (or combination thereof).</p>
            <h3>👤 Data sharing and privacy</h3>
            <p>For this job Measure will receive the data you share as well as these points of profile data: date of birth,
                gender, education level, income, zip and employment. The data you share in this task may be shared anonymously
                with third party clients and Measure will not share any image, video or file inputs you provide with a third
                party without your permission. All the data you share by completing this task is subject to Measure’s
                <a href="https://contributor.measureprotocol.com/app/privacy" target="_blank">privacy policy</a> and
                <a href="https://contributor.measureprotocol.com/app/terms" target="_blank">MSR App Terms of Use</a>.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Start screen recording. Open the <b>Lyft</b> app.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: "<p>In the app, tap on the <b>3 bars</b> (at the top left).</p>"
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Tap on <b>Ride history</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Scroll to the bottom. Please go back <b>as far as you can</b>, sometimes the history
                        takes a while to load at the bottom of the page. Stop screen recording.</p>`
                }
            ],
        },
    },
}

export const lyftDataTypes = {
    'lyft_ride_history': {
        data_type: 'lyft_ride_history',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/lyft-ride-history/logo.png',
        video_thumbnail: 'https://measure-static.s3.amazonaws.com/c2/retro/lyft-ride-history/video-thumbnail.jpg',
        video_url: 'https://measure-static.s3.amazonaws.com/c2/retro/lyft-ride-history/lyft.mp4',
        video_poster: 'https://measure-static.s3.amazonaws.com/c2/retro/lyft-ride-history/poster.png',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.lyft_ride_history
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.lyft_ride_history
        },
    },
}